import { memo } from 'react';
import { css } from '@emotion/react';
import { useNavSize } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { HamburgerMenuIcon, NakedButton } from '@frontend/design-system';
import { ICON_BUTTON_WIDTH, ICON_SIZE } from '../../../../constants';
import { useNavTrigger } from '../../../../layout';
import { iconButtonStyles } from '../../styles/styles';
import { TopBarFocusIds } from '../../utils/focus-registry';

export const HamburgerButton = memo(
  ({
    isSelected,
    isMobile,
    onClick,
    buttonRef,
  }: {
    isSelected: boolean;
    isMobile: boolean;
    onClick: () => void;
    buttonRef?: React.Ref<HTMLButtonElement>;
  }) => (
    <NakedButton
      onClick={onClick}
      ref={buttonRef}
      id={TopBarFocusIds.hamburger}
      trackingId='top_bar_bubble_nav_button'
      css={[
        css`
          align-items: center;
          color: ${theme.colors.white};
          display: flex;
          font-size: ${theme.fontSize(24)};
          font-weight: bold;
          height: 100%;
          justify-content: center;
          padding: ${theme.spacing(1)};
          transition: background 250ms ease-in-out;
          width: ${ICON_BUTTON_WIDTH}px;
          :hover {
            background: ${theme.colors.neutral5};
          }
        `,
        iconButtonStyles({ isSelected, isMobile }),
      ]}
    >
      <HamburgerMenuIcon color='default' size={ICON_SIZE} />
    </NakedButton>
  )
);
HamburgerButton.displayName = 'HamburgerButton';

export const HamburgerButtonWrapper = () => {
  const { setOpen, hamburgerButtonRef, open } = useNavTrigger();
  const navSize = useNavSize();
  const isXsmall = navSize.isLte('xsmall');
  const isMobile = navSize.isLte('mobile');

  if (!isXsmall) {
    return null;
  }

  return (
    <HamburgerButton
      isSelected={open}
      isMobile={isMobile}
      onClick={() => setOpen((p) => !p)}
      buttonRef={hamburgerButtonRef}
    />
  );
};
